import React from 'react';
import { useNowMinute } from '../../warm-transfer/utils';
import { IconButton } from '../IconButton/IconButton';

export interface ReportsTopBarActionsProps {
  onHelp?: () => void;
  onBell?: () => void;
}

export function ReportsTopBarActions({ onHelp, onBell }: ReportsTopBarActionsProps) {
  const time = useNowMinute();

  return (
    <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
      <span
        className="inline-flex h-8 items-center gap-1.5 rounded-[9px] border px-2.5"
        style={{
          background: 'rgba(15, 92, 69, 0.05)',
          borderColor: 'rgba(15, 92, 69, 0.10)',
        }}
      >
        <span className="elva-live h-[6px] w-[6px]" />
        <span className="text-[11.5px] font-semibold tracking-[0.01em]" style={{ color: '#0A4530' }}>
          Live
        </span>
        <span className="ml-0.5 font-[var(--font-mono)] text-[11px] text-[var(--ink-2)]">{time}</span>
      </span>

      <IconButton
        icon="help"
        size={32}
        onClick={onHelp}
        label="Help"
        className="rounded-[9px] border-[var(--cream-2)] bg-[var(--cream-1)] shadow-[var(--sh-1)] hover:bg-[var(--surface-mute)]"
      />
      <div className="relative">
        <IconButton
          icon="bell"
          size={32}
          onClick={onBell}
          label="Notifications"
          className="rounded-[9px] border-[var(--cream-2)] bg-[var(--cream-1)] shadow-[var(--sh-1)] hover:bg-[var(--surface-mute)]"
        />
        <span className="absolute right-1.5 top-1.5 h-1.5 w-1.5 rounded-full bg-[var(--terracotta)] shadow-[0_0_0_2px_var(--cream-1)]" />
      </div>
    </div>
  );
}
